module.exports = __webpack_public_path__ + "media/images/icons/footer-icon-facebook-5a66d42e5e7fc1594253be1c25270718.png";